import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { DossierIntervention } from 'app/models/dossier_intervention.model';
import { UserService as CoreUserService } from 'app/core/user/user.service';
import { User } from 'app/models/user.model';
import { Comment } from 'app/models/comment.model';
import { User as CoreUser } from 'app/core/user/user.types';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-communication-input',
  templateUrl: './communication-input.component.html'
})
export class CommunicationInputComponent implements OnInit {
    @Input() currentDossierIntervention: DossierIntervention = new DossierIntervention();
    @Input() users: User[] = [];

    @Output() send = new EventEmitter<Comment>();
    authUser: CoreUser;
    comment = new Comment();
    form: FormGroup;

    constructor(
        private _userService: CoreUserService
    ) { }

    get authUserName(): string {
        return this.authUser ? this.authUser.prenom + ' ' + this.authUser.nom : '';
    }
    ngOnInit(): void {
        this._userService.user$
            .subscribe((user: CoreUser) => {
                this.authUser = user;
            });

        this.resetForm();
    }

    resetForm(): void {
        this.form = new FormGroup({
            content: new FormControl('', [Validators.required]),
        });

        window.document.body.focus();
    }

    sendComment(): void {
        this.send.emit(new Comment(this.form.value));
        this.resetForm();
    }
}
